
  import {Component, Model, Prop, Vue} from "vue-property-decorator";

  @Component({name:'SimpleImageUpload'})
  export default class SimpleImageUpload extends Vue{

    @Model('change')
    imgUrl!:string;

    @Prop({required:false})
    width?:number;

    @Prop({required:false})
    height?:number;

    get uploadUrl(){
      // return process.env.VUE_APP_BASE_API + '/api/services/app/Client/Upload?id=2'
      return (this as any).$uploadUrl;
    }

    private handleAvatarSuccess(res: any) {
      if (res.success) {

        let url = `${res.result}`;
        if(this.width || this.height){
          url += '!';
          if(this.width){
            url+=`w${this.width}`;
          }
          if(this.height){
            url += `h${this.height}`;
          }
          url += 's';
        }

        this.$emit('change',url);
      }
    }


    private beforeAvatarUpload(file: any) {
      // const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) this.$message.error("上传头像图片大小不能超过 2MB!");
      return isLt2M;
    }




  }
